export var ActivityWalletStatus;
(function (ActivityWalletStatus) {
    ActivityWalletStatus["CAN_RECEIVE"] = "can_receive";
    ActivityWalletStatus["TRANSFERRING"] = "transferring";
    ActivityWalletStatus["RECEIVED"] = "received";
    ActivityWalletStatus["ERROR"] = "error";
    ActivityWalletStatus["EXPIRED"] = "expired";
    ActivityWalletStatus["REVOKED"] = "revoked";
})(ActivityWalletStatus || (ActivityWalletStatus = {}));
//# sourceMappingURL=ActivityWalletStatus.js.map